import { defineMessages } from 'react-intl';

export default defineMessages({
  claimGroupDocumentRelatedToProductTitlePage: {
    id: 'components.myaccount.claimGroupDocumentRelatedToProductPage.titlePage',
    defaultMessage: 'Claim group document related to product',
  },
  claimGroupProductInfoTitlePage: {
    id: 'components.myaccount.claimGroupProductInfoPage.titlePage',
    defaultMessage: 'Claim group product info',
  },
  previousButton: {
    id: 'global.stepsOrchestrator.previousButton',
    defaultMessage: 'Previous',
  },
  nextButton: {
    id: 'view.myaccount.component.nextButton',
    defaultMessage: 'Next',
  },
});
